import { StatusBadge } from "./StatusBadge";

export const BookingList = ({ items, onOpen }) => {
  if (!items.length) return <p className="border border-white/10 p-10 text-center text-zinc-400" data-testid="bookings-empty">No bookings here. Yet.</p>;
  return (
    <>
      <div className="hidden overflow-x-auto border border-white/10 md:block" data-testid="bookings-table">
        <table className="w-full text-left text-sm">
          <thead className="bg-[#111317]">
            <tr>{["Ref", "When", "Customer", "Service", "Status"].map((h) => <th key={h} className="eyebrow px-5 py-4 font-normal">{h}</th>)}</tr>
          </thead>
          <tbody>
            {items.map((b) => (
              <tr key={b.id} onClick={() => onOpen(b)} data-testid={`booking-row-${b.reference}`}
                className="cursor-pointer border-t border-white/10 transition-colors hover:bg-white/[0.03]">
                <td className="px-5 py-4 font-mono-x text-xs text-zinc-300">{b.reference}</td>
                <td className="px-5 py-4 text-zinc-100">{b.date}<span className="block text-xs text-zinc-400">{b.time_label}</span></td>
                <td className="px-5 py-4 text-zinc-100">{b.name}<span className="block text-xs text-zinc-400">{b.email}</span></td>
                <td className="px-5 py-4 text-zinc-300">{b.service_name}</td>
                <td className="px-5 py-4"><StatusBadge status={b.status} testid={`booking-status-${b.reference}`} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex flex-col gap-3 md:hidden" data-testid="bookings-cards">
        {items.map((b) => (
          <button key={b.id} onClick={() => onOpen(b)} data-testid={`booking-card-${b.reference}`}
            className="flex flex-col gap-2 border border-white/10 bg-[#111317] p-5 text-left">
            <div className="flex items-center justify-between"><span className="font-mono-x text-xs text-zinc-400">{b.reference}</span><StatusBadge status={b.status} /></div>
            <span className="text-lg font-bold text-zinc-50">{b.name}</span>
            <span className="text-sm text-zinc-300">{b.service_name}</span>
            <span className="text-sm text-zinc-400">{b.date} · {b.time_label}</span>
          </button>
        ))}
      </div>
    </>
  );
};
